import { MapBounds } from '../../../../app/shared/app-buyflow-map/app-buyflow-map.component';

export function calculateMapBoundsFromCenterPoint(
  latitude: number,
  longitude: number,
  zoomLevel: number,
  isMobile: boolean,
): MapBounds {
  const EARTH_CIR_METERS = 40075016.686;
  const degreesPerMeter = 360 / EARTH_CIR_METERS;
  let height, width;

  // search size of map in px
  height = 850;
  width = 600;

  const metersPerPixelEW = EARTH_CIR_METERS / Math.pow(2, zoomLevel + 8);
  const metersPerPixelNS =
    (EARTH_CIR_METERS / Math.pow(2, zoomLevel + 8)) *
    Math.cos(toRadians(latitude));

  const shiftMetersEW = (width / 2) * metersPerPixelEW;
  const shiftMetersNS = (height / 2) * metersPerPixelNS;

  const shiftDegreesEW = shiftMetersEW * degreesPerMeter;
  const shiftDegreesNS = shiftMetersNS * degreesPerMeter;

  const mapBounds = {
    northEastLat: latitude + shiftDegreesNS,
    northEastLng: longitude + shiftDegreesEW,
    southWestLat: latitude - shiftDegreesNS,
    southWestLng: longitude - shiftDegreesEW,
  };

  console.log(mapBounds);

  return mapBounds;
}

function toRadians(degrees) {
  return (degrees * Math.PI) / 180;
}
